import { getDocSection } from "@/api/docSections";
import { getRegions, getMacroregions } from "@/api/regions";
import { getDocType } from "@/api/docType";
import store from "@/store";

export default async (scheme, typeScheme) => {
  const { properties = {} } = scheme;
  const { type, section_id, regions, macroregion_id, type_id } = properties;

  // добавляем значение типа схемы
  // для отображения нужной при множественном кол-ве схем
  if (typeScheme && type) {
    type.value = typeScheme;
  }
  if (section_id) {
    const fetchData = await getDocSection();
    const data = {
      items:
        section_id.section == "regional"
          ? fetchData.filter(
              (el) => el.type_id === store.getters.types.regional
            )
          : fetchData.filter(
              (el) => el.type_id === store.getters.types.federal
            ),
      params: { key: "id", label: "name", multiple: false },
    };
    Object.assign(section_id, data);
  }

  if (type_id) {
    let fetchData = await getDocType();
    fetchData = fetchData.map((el) => {
      return {
        ...el,
        name:
          el.type == "regional"
            ? "Региональные инструкции"
            : "Федеральные инструкции",
      };
    });
    const data = {
      items: fetchData,
      params: { key: "id", label: "name", multiple: false },
    };
    Object.assign(type_id, data);
  }

  if (regions) {
    let regionsItems = await getRegions();
    regionsItems = regionsItems.regions.sort((a, b) => {
      return b.name > a.name ? 1 : -1;
    });
    regionsItems = regionsItems.sort((a, b) => {
      return b.is_global ? 1 : -1;
    });
    const data = {
      items: regionsItems,
      params: { key: "id", label: "name", multiple: true },
    };
    Object.assign(regions, data);
  }

  if (macroregion_id) {
    const macroregions = await getMacroregions();
    const data = {
      items: macroregions.macroregions,
      params: { key: "id", label: "name", multiple: false },
    };
    Object.assign(macroregion_id, data);
  }

  return scheme;
};
